<template>
    <Progressbar v-if="loading && !order.id" />
    <NetworkError v-else-if="errors" @tryAgain="getData" />
    <div class="flex flex-row gap-6 w-full h-full" v-else>
        <div class="flex flex-1 flex-col overflow-hidden">
            <div class="flex items-center">
                <div class="alert bg-green-custom-1 text-green-custom-2 h-8 lg:h-12 py-0 px-2 md:px-4">
                    <span class="m-auto"> {{ __('Return request details') }}</span>
                </div>
                <!-- <label class="btn btn-dark btn-outline mr-3" @click="exportOrder(order)"><ArrowDownTrayIcon class="w-5 h-5" /> <span class="hidden md:inline mr-2"> </span>{{ __('Invoice') }}</label> -->
            </div>
            <div class="card bg-white mt-4">
                <div class="card-body">
                    <div class="grid grid-cols-2 gap-4 xl:grid-cols-4">
                        <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Return number') }}:</span> <span>{{ order.id }}</span></p>
                        <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Order Id') }}:</span> <span>{{ order.order_id }}</span></p>
                                                <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Total Amount') }}:</span> <span>
                                {{ order.amount?.toLocaleString('en-Us') }}</span>
                            <Currency />
                        </p>
                        <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Registration date') }}:</span> <span>{{
                            order.created_at }}</span></p>
                    </div>
                    <div class="divider min-h-0 my-0"></div>
                    <p class="col-span-full text-sm md:text-base"><span class="text-gray-custom-1 ">{{ __('Address') }}:</span> <span>{{
                            order.shipping_address }}</span></p>
                    <div class="divider min-h-0 my-0"></div>
                    <!-- <ul class="steps compa">
                        <li data-content="✓" class="step" v-for="step in meta.steps"
                            :class="{ 'step-success': order.steps.includes(step.name) }">{{ step.label }}</li>
                    </ul> -->
                    <div class="alert alert-secondary flex-row justify-center text-xs md:text-sm w-auto md:px-16 gap-2 md:mx-auto" v-if="order.status == 'canceled'"><XCircleIcon class="w-5 h-5" /> {{ __('Your refund request has been canceled.') }}</div>
                </div>
            </div>
            <div class="flex justify-between items-center mt-3">
                <div class="card-title">{{ __('Return requests') }}</div>
                <label class="btn btn-sm btn-error" for="cancel-modal" v-if="order.status == 'pending'">{{ __('Cancel request') }}</label>
            </div>
            <div
                class="card product-item mt-4 bg-white scrollbar-thin scrollbar-thumb-base-300 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-track-base-200">
                <div class="card-body p-0">
                    <div class="overflow-x-auto">
                        <table class="table w-full table-compact md:table-normal">
                            <thead class="border-b">
                                <tr>
                                    <th>#</th>
                                    <th>{{ __('Title') }}</th>
                                    <th>{{ __('Reason for return') }}</th>
                                    <th>{{ __('Status') }}</th>
                                    <th>{{ __('Quantity') }}</th>
                                    <th>{{ __('Refund amount') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(product,index) in order.products">
                                    <td class="text-center">{{ index +1 }}</td>
                                    <td class="text-center">{{ product.title }}</td>
                                    <td class="text-center">{{ product.reason }}</td>
                                    <td class="text-center">{{ __(product.status.capitalize()) }}</td>
                                    <td class="text-center">{{ product.quantity }}</td>
                                    <td class="text-center">
                                        {{ product.amount.toLocaleString() }}<Currency />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
     <Teleport to="#app">
        <input type="checkbox" id="cancel-modal" class="modal-toggle" />
        <label class="modal" for="cancel-modal">
            <label class="modal-box" for="">
                <h3 class="font-bold text-lg">{{ __('Cancel request') }}</h3>
                <p class="py-4">
                    {{ 
                    __('Are you sure you want to cancel your request?') }}
                </p>
                <div class="modal-action">
                    <label class="btn btn-error btn-sm" for="cancel-modal">{{ __('Cancel') }}</label>
                    <label class="btn btn-primary btn-sm" @click="updateOrderReturn" for="cancel-modal">{{
                        __('Cancel return') }}</label>
                </div>
            </label>
        </label>
    </Teleport>
</template>
<script setup>
import { computed, onMounted, onUpdated, ref } from 'vue';
import {
    XCircleIcon,
} from '@heroicons/vue/24/outline'
import Currency from '../../svg/Currency.vue';
import useOrders from "../../../composables/shop/order";
const { errors, loading, order, getOrder, exportOrder,updateOrderReturn, meta } = useOrders();
const getData = () => getOrder(true);
onMounted(() => {
    getData()
});
</script>